import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

function SurveyImage3() {
  return (
    <StaticImage src={'../../../../src/assets/survey/image3.jpg'} alt="" />
  );
}

export default SurveyImage3;
